await loadComponent('./components/mc-element.js', false);
await loadComponent('./res/mc-shopify.js', false); 

class CollectionFilters extends McElement {

  connectedCallback() {
    window.addEventListener('filter:change', this.onFilterChange.bind(this));
    
    // Add swipe to close functionality on mobile when offcanvas is shown
    this.addEventListener('shown.bs.offcanvas', () => {
      if (window.innerWidth <= 767) {
        this.initSwipeToClose();
      }
    });
  }
  
  initSwipeToClose() {
    const header = this.querySelector('.offcanvas-header');
    if (!header) {
      console.log('Header not found');
      return;
    }
    
    let startY = 0;
    let currentY = 0;
    let isDragging = false;
    
    const handleTouchStart = (e) => {
      const touch = e.touches[0];
      const rect = header.getBoundingClientRect();
      
      // Check if touch is on the header
      if (touch.clientY >= rect.top && touch.clientY <= rect.bottom) {
        isDragging = true;
        startY = touch.clientY;
        currentY = startY;
        this.classList.add('dragging');
        this.style.transition = 'none';
        // Prevent background scrolling
        document.body.style.overflow = 'hidden';
        document.body.style.touchAction = 'none';
      }
    };
    
    const handleTouchMove = (e) => {
      if (!isDragging) return;
      
      // Prevent default to stop background scrolling
      e.preventDefault();
      e.stopPropagation();
      
      currentY = e.touches[0].clientY;
      const deltaY = currentY - startY;
      
      // Only allow dragging down (positive deltaY)
      if (deltaY > 0) {
        // Move the entire panel down
        this.style.transform = `translateY(${deltaY}px)`;
      }
    };
    
    const handleTouchEnd = (e) => {
      if (!isDragging) return;
      
      isDragging = false;
      this.classList.remove('dragging');
      this.style.transition = 'transform 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      
      // Re-enable background scrolling
      document.body.style.overflow = '';
      document.body.style.touchAction = '';
      
      const deltaY = currentY - startY;
      
      // If dragged more than 150px or 25% of screen height, close the panel
      if (deltaY > 150 || deltaY > window.innerHeight * 0.25) {
        // Animate closing
        this.style.transform = `translateY(100%)`;
        
        // Wait for animation then close
        setTimeout(() => {
          const bsOffcanvas = bootstrap.Offcanvas.getInstance(this);
          if (bsOffcanvas) {
            bsOffcanvas.hide();
          } else {
            // Fallback: trigger close button
            const closeBtn = this.querySelector('[data-bs-dismiss="offcanvas"]');
            if (closeBtn) {
              closeBtn.click();
            }
          }
          // Reset transform after hiding
          this.style.transform = '';
          this.style.transition = '';
        }, 300);
      } else {
        // Snap back to open position
        this.style.transform = 'translateY(0)';
        
        // Clean up after animation
        setTimeout(() => {
          this.style.transform = '';
          this.style.transition = '';
        }, 300);
      }
    };
    
    header.addEventListener('touchstart', handleTouchStart, { passive: true });
    header.addEventListener('touchmove', handleTouchMove, { passive: false }); // passive: false to allow preventDefault
    header.addEventListener('touchend', handleTouchEnd, { passive: true });
    header.addEventListener('touchcancel', handleTouchEnd, { passive: true });
  }
  
  onFilterChange = () => {
    const form = this.querySelector('form');
    if(!form) {
      console.warn('CollectionFilters: form not found');
      return;
    }

    let data = this.deduplicate(new FormData(form));
    
    // Costruisci manualmente i parametri per gestire valori complessi
    const params = [];
    for (const [key, value] of data.entries()) {
      // Salta sort_by=manual (è il default)
      if (key === 'sort_by' && value === 'manual') {
        continue;
      }
      
      // Encode correttamente il valore
      params.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
    
    const queryString = params.join('&');
    const url = queryString ? `${form.action}?${queryString}` : form.action;
    
    console.log('CollectionFilters: requesting URL:', url);
    console.log('CollectionFilters: params:', params);
    
    axios({
      url: url,
      method: 'GET',
      headers: {
        'Accept': 'text/html,*/*'
      }
    }).then(response => {
      console.log('CollectionFilters: response received, dispatching event');
      // Aggiorna il contenuto dell'elemento usando la funzione utility McUtils.reloadElement
      McUtils.reloadElement(response.data, this, this.getSelector());
      window.history.replaceState(null, null, url);
      McShopify.customEvent('collection:filters', {
        filters: Array.from(data.entries()).map(([key, value]) => ({name: key, value})), 
        response: response.data,
        url: url
      });
    }).catch(error => {
      console.error('CollectionFilters: error fetching filters:', error);
      if (error.response) {
        console.error('Response status:', error.response.status);
        console.error('Response data:', error.response.data);
      }
    });
  }

  deduplicate = (formData) => {
    const deduplicated = new FormData();
    const seen = new Set();

    for (const [key, value] of formData.entries()) {
      const identifier = `${key}:${value}`;
      if (!seen.has(identifier)) {
        seen.add(identifier);
        deduplicated.append(key, value);
      }
    }

    return deduplicated;
  }
}

if (!customElements.get('collection-filters')) {
  customElements.define('collection-filters', CollectionFilters);
}

window.CollectionFilters = CollectionFilters;